module.exports = __webpack_public_path__ + "static/img/raas_train_6.fc6b8c4.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/raas_train_6.svg
// module id = FEde
// module chunks = 0